import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted} from "vue";
import { useRoute, useRouter } from 'vue-router';
type Props = {
    amount: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'withdraw-submitted',
  props: {
    amount: null
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    amount: number;
}


const confirmedAmount = ref(0);
const router = useRouter();
const routeTo = () =>{
    router.push(`/balance`)
}
onMounted(() => {
    confirmedAmount.value = props.amount;
});

const __returned__ = { props, confirmedAmount, router, routeTo, ref, onMounted, useRoute, useRouter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})